import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  Observable,
  Subject,
  combineLatest,
  firstValueFrom,
  share,
  tap,
} from 'rxjs';

@Injectable()
export class RandomImageService {
  private fetchDone = false;
  private inProgress$: Subject<any> = new Subject<any>();

  private selectableNoGender: string[] = [];
  private selectableMale: string[] = [];
  private selectableFemale: string[] = [];

  public femaleNames;
  public maleNames;
  private femaleImg = [
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/1+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/14+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/18+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/19+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/22+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/25+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/28+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/31+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/37+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/4+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/40+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/43-1+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/52+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/53+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/55+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/56+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/58+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/59+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/6+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/65+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/68+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/72+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/73+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/74+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/77+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/81+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/82+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/83+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/86+fe-ma-le.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/93+fe-ma-le.png.webp',
  ];
  private maleImg = [
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/26ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/21ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/48ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/81ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/18ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/3ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/84ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/73ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/78ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/82ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/52ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/71ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/72ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/33ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/35ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/49ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/29ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/31ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/6ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/15ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/45ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/57ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/74ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/34ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/42ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/7ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/12ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/22ma-l-e.png.webp',
    'https://d10a6kin4dgxel.cloudfront.net/private/compressed/lp/profile_imgs/76ma-l-e.png.webp',
  ];

  constructor(private http: HttpClient) {}

  fetchNamesFromServer(): Observable<any> {
    this.fetchDone = true;
    const maleNamesRequest = this.http.get(
      'https://d10a6kin4dgxel.cloudfront.net/static/maleNames.json',
    );
    const femaleNamesRequest = this.http.get(
      'https://d10a6kin4dgxel.cloudfront.net/static/femaleNames.json',
    );

    return combineLatest([maleNamesRequest, femaleNamesRequest]).pipe(
      share(),
      tap(([maleNames, femaleNames]) => {
        this.maleNames = maleNames;
        this.femaleNames = femaleNames;
      }),
      tap(() => (this.fetchDone = false)),
      tap(() => this.inProgress$.next(true)),
    );
  }

  private requireFetch(): boolean {
    return (
      !this.fetchDone &&
      (!this.maleNames ||
        !this.femaleNames ||
        Object.keys(this.maleNames).length === 0 ||
        Object.keys(this.femaleNames).length === 0)
    );
  }

  async checkGender(firstName: string): Promise<any> {
    firstName = firstName.toLowerCase();

    if (this.requireFetch()) {
      await firstValueFrom(this.fetchNamesFromServer());
    } else {
      await firstValueFrom(this.inProgress$);
    }

    try {
      let gender;
      if (firstName in this.maleNames) {
        gender = this.maleNames[firstName];
      } else if (firstName in this.femaleNames) {
        gender = this.femaleNames[firstName];
      } else {
        gender = 'unknown';
      }
      return gender;
    } catch (error) {
      return error;
    }
  }

  getRandomImageNoGender(): string {
    if (this.selectableNoGender.length === 0) {
      this.selectableNoGender = [...this.maleImg, ...this.femaleImg];
      this.selectableNoGender.sort(() => Math.random() - 0.5);
    }

    return this.selectableNoGender.pop();
  }

  async getRandomImage(firstName: string): Promise<any> {
    if (this.selectableMale.length === 0) {
      this.selectableMale = [...this.maleImg];
      this.selectableMale.sort(() => Math.random() - 0.5);
    }

    if (this.selectableFemale.length === 0) {
      this.selectableFemale = [...this.femaleImg];
      this.selectableFemale.sort(() => Math.random() - 0.5);
    }

    if (firstName == null) {
      return this.getRandomImageNoGender();
    }

    try {
      const gender = await this.checkGender(firstName);
      if (gender === 'm') {
        return this.selectableMale.pop();
      }
      return this.selectableFemale.pop();
    } catch (error) {
      return error;
    }
  }
}
